import {FormattableString} from "../FormattableString";
import Translations from "../i18n/Translations";

export function translation(message: string, args?: Record<string, any> | null): string;
export function translation(message: FormattableString): string;
export function translation(messages: FormattableString[]): string;

export function translation(messages: FormattableString[] | FormattableString | string, args?: Record<string, any> | null | undefined): string {
	const formatter = Translations.getDefaultFormatter();
	if (!Array.isArray(messages)) {
		return formatter.format(messages as string, args);
	}

	for (const message of messages) {
		const text = formatter.format(message)
		if (message.text === text || text === "-") {
			continue;
		}

		return text;
	}

	// Every key missed: echo the last (most generic) one like the single-key overload does.
	// An empty string is not a harmless fallback - callers read it as "no message" (an empty
	// confirm dialog, or a validation error that MvvmContextState unsets as if valid).
	return messages.length === 0 ? "" : formatter.format(messages[messages.length - 1]);
}
